import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { tw } from "@/utils";

interface Page {
  name: string;
  href: string;
}

interface BreadcrumbsProps {
  pages: Page[];
}

export const Breadcrumbs = ({ pages }: BreadcrumbsProps) => {
  const navigate = useNavigate();
  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ul className="flex gap-x-1">
        {pages.map((page, index) => {
          const isLast = index === pages.length - 1;
          return (
            <li
              key={page.name}
              className={tw(
                "flex items-center gap-x-1 text-xs",
                isLast ? "text-primary-500" : "text-neutral-500",
              )}
            >
              <button onClick={() => navigate(page.href)} type="button">
                {page.name}
              </button>
              {!isLast && (
                <ChevronRight size={20} className="text-primary-700" />
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
